import request from '@/utils/request';

//查询决策图版本审计
export function getDiagramVersionList(values) {
  return request('/decision/diagram-version', {
    method: 'GET',
    params: values,
  });
}
//版本回滚
export function rollBack(values) {
  return request('/decision/diagram-version/roll-back/', {
    method: 'PUT',
    params: values,
  });
}
//申请发布
export function applyForRelease(id) {
  return request(`/decision/diagram-version/apply-for-release/${id}`, {
    method: 'PUT',
  });
}
//查询版本信息列表
export function getApprovalList() {
  return request('/decision/diagram-approval', {
    method: 'GET',
  });
}

// 设置为当前版本
export function setToCurrentVersion(diagramVersionAuditId) {
  return request(
    `/decision/diagram-version/set-to-current-version/${diagramVersionAuditId}`,
    {
      method: 'PUT',
    },
  );
}

// 决策图版本管理编辑
export function updateDiagramVersionAudit(diagramVersionAuditId, data) {
  return request(`/decision/diagram-version/${diagramVersionAuditId}`, {
    method: 'PUT',
    data: data,
  });
}

// 获取基础版本下拉数据
export function queryDiagramVersion(params) {
  return request('/decision/diagram-version', {
    method: 'GET',
    // params: values,
    params: params,
  });
}

// 决策图版本管理新增
export function addDiagramVersion(params) {
  return request('/decision/diagram-version', {
    method: 'POST',
    data: params,
  });
}

// 查询版本list
export const getVersion = (params) => {
  return request('/decision/diagram/version', {
    method: 'GET',
    params: params,
  });
};
